<template>
  <BaseModal
    :id="`modal-show-section-${sectionId}-details`"
    :show.sync="$show"
    :title="title"
    size="md"
    :hide-footer="true"
  >
    <div ref="modal__body" class="body">
      <!-- <h5 class="font-weight-bold my-4">
        Online meetings
      </h5> -->
      <div
        v-for="(meeting, idx) in sortedMeetingsList"
        :key="idx"
        ref="container__meeting-date"
        class="mb-1 container__meeting-date"
      >
        {{ ` ${formatedDatetime(meeting, 'ddd, MMM D, YYYY HH:mma')} ${cityTimezone} time` }}
      </div>
    </div>
  </BaseModal>
</template>

<script>
// import moment from "moment";
import { datetimeMixin } from '@/mixins/datetimeMixin';
import BaseModal from '@/components/base-components/BaseModal';

export default {
  components: { BaseModal },

  mixins: [datetimeMixin],

  props: {
    sectionId: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    meetingsList: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    sortedMeetingsList() {
      return this.sortDateArray(this.meetingsList, 'asc');
    }
  },

  methods: {
    // show() {
    //   this.$bvModal.show(`modal-show-section-${this.sectionId}-details`);
    // },

    hide() {
      this.$bvModal.hide(`modal-show-section-${this.sectionId}-details`);
    }
  }
};
</script>

<style lang="scss" scoped></style>
